import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes, NotificationTemplateEnum } from '@finxone-platform/shared/sys-config-types';

export const profilePushTranslations = {
  [Locale.en_GB]: {
    INDIVIDUAL_PROFILE_UPDATE_TITLE: 'Personal Profile Changed',
    INDIVIDUAL_PROFILE_UPDATE_DESCRIPTION:
      'Your personal profile information has been successfully updated. Check your profile details to ensure everything is correct.',
    BUSINESS_PROFILE_UPDATE_TITLE: 'Business Profile Modified',
    BUSINESS_PROFILE_UPDATE_DESCRIPTION:
      'Your business profile information has been successfully updated. Check your profile details to ensure everything is correct.',
  },
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateProfilePushAlerts = (translations: any) => ({
  [NotificationTemplateEnum.INDIVIDUAL_PROFILE_UPDATE]: {
    name: 'Individual Profile Update',
    type: AlertTypes.INFO,
    title: translations.INDIVIDUAL_PROFILE_UPDATE_TITLE,
    description: translations.INDIVIDUAL_PROFILE_UPDATE_DESCRIPTION,
  },
  [NotificationTemplateEnum.BUSINESS_PROFILE_UPDATE]: {
    name: 'Business Profile Update',
    type: AlertTypes.INFO,
    title: translations.BUSINESS_PROFILE_UPDATE_TITLE,
    description: translations.BUSINESS_PROFILE_UPDATE_DESCRIPTION,
  },
});
